import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Person } from '../types';

interface Input {
	people: Person[];
	type: 'any' | 'feedback' | 'recognition';
}

export const useMonthlyInteraction = ({ people, type }: Input) => {
	const [noInteractionPeopleInMonth, interactionPeopleInMonth] = useMemo(() => {
		const noInteraction: Person[] = [];
		const interaction: Person[] = [];

		people.forEach((person) => {
			let interactionCount = 0;
			const feedback_count = person.feedback_given_count + person.feedback_requested_count;

			if (type === 'any') {
				interactionCount = person.recognition_count + feedback_count;
			} else if (type === 'feedback') {
				interactionCount = feedback_count;
			} else if (type === 'recognition') {
				interactionCount = person.recognition_count;
			}

			if (interactionCount > 0) {
				interaction.push(person);
			} else {
				noInteraction.push(person);
			}
		});
		return [noInteraction, interaction];
	}, [people, type]);

	return {
		noInteractionPeopleInMonth,
		interactionPeopleInMonth,
	};
};

export const useDaysSinceLastInteraction = (interactionDate?: number | null) => {
	return interactionDate ? Math.round((new Date().getTime() - new Date(interactionDate * 1000).getTime()) / 86400000) : -1;
};

export const useLastInteractedDate = (person: Person) => {
	return person.last_recognized_at;
};

export const useInteractionTooltip = (person: Person) => {
	const { t } = useTranslation('tracker_widget');

	const interactions = [];
	if (person.recognition_count > 0) {
		interactions.push(
			t('person_list.recognition_count_tooltip', {
				count: person.recognition_count,
			})
		);
	}

	return interactions.join(', ');
};
